var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNextArrowIcon = function SvgNextArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.963,
    height: 19.968
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108687",
    d: "M1.419 11.381h15.744l-6.168 6.167a1.418 1.418 0 0 0 2.006 2.006l8.55-8.548a1.414 1.414 0 0 0 .409-1.021v-.022c0-.01-.007-.022-.007-.033a1.1 1.1 0 0 0-.28-.776 1.428 1.428 0 0 0-.125-.19L12.998.416a1.418 1.418 0 0 0-2.006 2.006l6.125 6.125h-15.7a1.419 1.419 0 1 0 0 2.837",
    fillRule: "evenodd"
  })));
};
export default SvgNextArrowIcon;